import React, { useEffect, useState } from 'react'
import LowerLeft from './LowerLeft';
import LowerRight from './LowerRight';
import DetilnImg from '../pageStructure/DetilnImg';
import axios from 'axios';
import useGetFacultyImages from '../../hooks/useGetFacultyImages';



const facultyPage = {
  heading: 'Faculty of Photogrammetry & Remote Sensing',
  content: ['The faculty offers fundamental and advanced level of training in the domain of Photogrammetry and Remote Sensing. The theoretical sessions and practical demonstrations inculcate a thorough understanding of fundamental concepts and processes amongst the trainees.  Participants are provided detailed operating instructions and sufficient hands-on practice on latest software’s during the practical exercises. Both online as well as offline courses are offered to cater to the in-house training requirements of the Organization and also to meet the custom requirements of various government and private agencies. The courses on Digital Photogrammetry, Image Processing, Drone Survey / Drone Data processing and LiDAR Data Processing etc.  are designed to make the trainees ready   for production environment in industry and prepare them for making meaningful contributions in real world  projects. The faculty is equipped with state-of-the-art facilities in class-rooms and laboratories. The trainings are imparted by quality subject experts having rich experience in the spheres of Photogrammetry and Remote Sensing.']
}

const FacultyPhotogrammetry = () => {
  const [faculty, setFaculty] = useState(null)
  const [headData, setHeadData] = useState(null);
  const facultyImages = useGetFacultyImages('Faculty_P&RS');
  const getFacultyMember = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/admin/faculty_member_faculty1/Faculty_P&RS`;
      const res = await axios.get(url);
      setFaculty(res?.data?.data)
    } catch (error) {
      console.log(error)
    }
  }

  const getHeadFaculty = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/sadmin/view_admin`;
      const res = await axios.get(url);
      const headData = res.data.admins.find(item => item.faculty === 'Faculty_P&RS');
      setHeadData(headData);
    } catch (error) {
      console.log(error)

    }
  }

  useEffect(() => {
    getFacultyMember();
    getHeadFaculty();
  }, [])
  
  return (
    <div className='m-2 md:m-4 p-2 md:p-6'>
      <DetilnImg heading={facultyPage.heading} text={facultyPage.content} images={facultyImages} />
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2  m-4 md:m-6 lg:m-8 rounded-md gap-2 md:gap-4 lg:gap-6'>
        <LowerLeft  headData={headData} />
        <LowerRight data={faculty} />
      </div>
    </div>
  )
}

export default FacultyPhotogrammetry